const instagram = "https://www.instagram.com/danielbricen/";
const twitter = "https://twitter.com/Danielbricen";
const youtube = "https://www.youtube.com/@Danielbricen";
const tiktok = "https://www.tiktok.com/@daniel.bricen";
const facebook =
	"https://www.facebook.com/profile.php?id=100083328009915&mibextid=LQQJ4d";

export { instagram, twitter, tiktok, youtube, facebook };
